import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const MegaphoneIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescMarketing">Megaphone</desc>
      <path
        className="background"
        d="M127.5 0C57.2 0 0 57.2 0 127.5S57.2 255 127.5 255 255 197.8 255 127.5 197.8 0 127.5 0z"
      />
      <path
        className="accent"
        d="M152.4 31.4c5.2 4.2 5.3 5 1.9 10.9-2.7 4.7-5.4 9.3-8 14-1.5 2.7-3.6 4.1-6.7 2.9-3.2-1.3-3.4-4.2-2.2-6.8 3-7.1 5.2-14.7 9.9-21.1 1.7.1 3.4.1 5.1.1zM106.6 56.6c7.7-.3 14.5 2.6 20.9 6.2 25.1 14.2 44.7 34 58.4 59.5 3.5 6.4 5.4 13.3 5 20.8-.5 8.1-5.9 13.7-14 14.2-8.4.5-16-2.4-23-6.4-26.1-15.1-46.7-35.6-59.9-62.9-2.1-4.4-3.3-9-3.6-13.9-.8-11.2 5.1-17.5 16.2-17.5zm62.2 84.4c5.6.1 6.7-1 6.2-5.2-.4-3.8-1.9-7.4-3.7-10.8-11.8-21-28.3-37.3-49.2-49.1-3.5-2-7.2-3.3-11.3-3.5-3.4-.2-5 1.6-4.6 5 .4 3.3 1.4 6.4 2.9 9.3 10.3 20 25.4 35.5 44.3 47.6 5.1 3.3 10.3 6.4 15.4 6.7z"
      />
      <path
        className="accent"
        d="M87.9 88c2.3 6.2 5.4 12 8.7 17.8 1.3 2.3-.1 5-.6 7.5-1.3 5.8-3.3 11.4-6.4 16.6-1.2 2-1.4 3.9-.5 6 4.5 10.9 12.3 18.4 23.1 23 2.4 1 4.1 0 5.9-1.1 6.3-3.7 13.1-5.9 20.4-6.9 1.1-.2 2.3-.6 3.3.1 5.3 3.2 10.7 6.2 16.8 8.4-1.8 2-3.6 1.4-5.1 1.3-16.2-.2-29.7 5.8-40.9 17.4-3 3-6.1 5.9-9 9-5.8 6.4-12.8 7.6-20.5 4.6-13.8-5.2-23.3-14.8-27.6-29-2.1-6.9-.9-12.9 4.7-18.1 5.4-5 10.8-10 15.3-15.9 7.6-9.9 11.2-21.1 11.4-33.5v-6.7c.3-.3.7-.4 1-.5z"
      />
      <path
        className="accent"
        d="M139.8 210.9c-5.6-.3-10.1-3.3-14.7-6.2-5.6-3.6-10.6-8.1-16.7-10.8-1.7-.8-1.6-1.7-.5-2.9 3.8-3.8 7.5-7.7 11.5-11.3 2.3-2.1 5.3-1.8 8.1-1 2.9.8 5.6 1.9 8.4 3 3.9 1.6 7.8 2.4 11.9.8 1.5-.6 3.4-.8 5-.7 3.8.4 7.4 1.6 9 5.3 1.6 3.7-1.1 6.1-3.3 8.5-3.6 4-7.3 7.9-10.9 11.9-2 2.3-4.6 3.5-7.8 3.4zM172.5 80c-4.3.1-6.7-4.1-4.1-7.5 4.5-5.8 9.5-11.1 14.7-16.3 2.1-2.1 4.8-1.1 6.9.8 2 1.8 3.6 4.4 1.7 6.7-5.1 6-11 11.2-17.4 15.9-.6.3-1.4.3-1.8.4zM216.3 98.6c0 1.6-1.5 3.2-3.7 4.2-5.7 2.5-11.4 4.8-17.2 7.1-2.9 1.1-5.8 1.3-7.2-2.1-1.3-3.2.3-5.3 3.2-6.8 5.3-2.9 10.5-6.2 15.8-9 4.5-2.4 9 .4 9.1 6.6zM133.5 98.4c10.1 0 18.5 11.7 14.9 20.4-1.1 2.8-2.3 3.5-4.9 1.2-5-4.6-10-9.2-14.3-14.4-1.2-1.4-3.7-2.5-2.6-4.8 1-2 3.4-2.2 5.6-2.5.4 0 .8.1 1.3.1z"
      />
    </Icon>
  );
};

export default MegaphoneIcon;
